import * as React from 'react'
import type { RouteObject } from 'react-router'

const WalletDetail = React.lazy(
    () => import('../views/WalletDetail/WalletDetail'),
)
const AccountActivities = React.lazy(
    () => import('../views/AccountActivities/AccountActivities'),
)
const GiftCard = React.lazy(() => import('../views/GiftCard/GiftCard'))
const Earned = React.lazy(() => import('../views/Earned/Earned'))
const MagneticCards = React.lazy(
    () => import('../views/MagneticCards/MagneticCards'),
)
const EntryControlEvents = React.lazy(
    () => import('../views/EntryControlEvents/EntryControlEvents'),
)

export const WalletRouter: RouteObject[] = [
    {
        path: '/',
        element: <WalletDetail />,
    },
    {
        path: '/account-activities',
        element: <AccountActivities />,
    },
    {
        path: '/gift-card',
        element: <GiftCard />,
    },
    {
        path: '/earned',
        element: <Earned />,
    },
    {
        path: '/magnetic-cards',
        element: <MagneticCards />,
    },
    {
        path: '/entry-control-events',
        element: <EntryControlEvents />,
    },
]
